/* NeoCharge Installer Guide: kit tabs, drawer, scroll-spy, search.
   The local prototype and the Impact theme share this file. No dependencies. */
(function () {
  'use strict';
  var root = document.querySelector('.ncig');
  if (!root) return;

  var KITS = { 'split-core': 'Split-core CTs', 'flex': 'Flex (Rogowski)' };
  var STORE_KEY = 'ncig-kit';

  function store(get, val) {
    try {
      if (get) return window.localStorage.getItem(STORE_KEY);
      window.localStorage.setItem(STORE_KEY, val);
    } catch (e) { return null; }
  }

  /* ---------- kit state ---------- */
  function initialKit() {
    var q = new URLSearchParams(window.location.search).get('kit');
    if (q === 'rogowski') q = 'flex';
    if (q && KITS[q]) { store(false, q); return q; }
    var s = store(true);
    return s && KITS[s] ? s : 'split-core';
  }

  function setKit(kit, persist) {
    if (!KITS[kit]) return;
    root.setAttribute('data-kit', kit);
    if (persist !== false) store(false, kit);
    root.querySelectorAll('[data-set-kit]').forEach(function (b) {
      var on = b.getAttribute('data-set-kit') === kit;
      if (b.getAttribute('role') === 'tab') {
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      } else {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      }
    });
  }

  var uid = 0;
  root.querySelectorAll('.ncig-kitgroup').forEach(function (group) {
    var panels = Array.prototype.slice.call(group.querySelectorAll(':scope > .ncig-kit'));
    var kits = panels.map(function (p) { return p.getAttribute('data-kit'); });
    if (kits.indexOf('split-core') > -1 && kits.indexOf('flex') > -1) {
      group.classList.add('ncig-kitgroup--tabbed');
      var bar = document.createElement('div');
      bar.className = 'ncig-kitgroup__tabs';
      bar.setAttribute('role', 'tablist');
      bar.setAttribute('aria-label', 'Sensor kit');
      ['split-core', 'flex'].forEach(function (k) {
        var panel = panels[kits.indexOf(k)];
        var id = 'ncig-kit-' + (++uid);
        panel.id = panel.id || id + '-p';
        panel.setAttribute('role', 'tabpanel');
        var b = document.createElement('button');
        b.type = 'button';
        b.id = id + '-t';
        b.setAttribute('role', 'tab');
        b.setAttribute('data-set-kit', k);
        b.setAttribute('aria-controls', panel.id);
        panel.setAttribute('aria-labelledby', b.id);
        b.textContent = KITS[k];
        bar.appendChild(b);
      });
      bar.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        var next = root.getAttribute('data-kit') === 'flex' ? 'split-core' : 'flex';
        setKit(next);
        var t = bar.querySelector('[data-set-kit="' + next + '"]');
        if (t) t.focus();
      });
      group.insertBefore(bar, group.firstChild);
    } else if (kits.length === 1) {
      var only = kits[0];
      var other = only === 'flex' ? 'split-core' : 'flex';
      group.classList.add('ncig-kitgroup--single');
      group.setAttribute('data-only', only);
      var note = document.createElement('p');
      note.className = 'ncig-kit__other';
      note.innerHTML = 'This part applies to the <strong>' + KITS[only] + '</strong> kit only. ' +
        '<button type="button" data-set-kit="' + only + '">Show it</button>';
      group.appendChild(note);
    }
  });

  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-set-kit]');
    if (!b) return;
    var anchorTop = b.getBoundingClientRect().top;
    setKit(b.getAttribute('data-set-kit'));
    // Keep the clicked control under the finger so the page doesn't jump when panels change height.
    var delta = b.getBoundingClientRect().top - anchorTop;
    if (Math.abs(delta) > 1) window.scrollBy(0, delta);
  });

  root.classList.add('js-kit');
  setKit(initialKit(), false);

  // A deep link into the other kit's content switches kits so the target is visible.
  function revealHash() {
    if (!window.location.hash) return;
    var t;
    try { t = document.getElementById(decodeURIComponent(window.location.hash.slice(1))); } catch (e) { return; }
    var panel = t && t.closest('.ncig-kit[data-kit]');
    if (panel && panel.getAttribute('data-kit') !== root.getAttribute('data-kit')) {
      setKit(panel.getAttribute('data-kit'));
      t.scrollIntoView();
    }
  }
  revealHash();
  window.addEventListener('hashchange', revealHash);

  /* ---------- drawer (mobile) ---------- */
  var toggles = root.querySelectorAll('[data-ncig-drawer]');
  function drawer(open) {
    root.classList.toggle('is-drawer-open', open);
    toggles.forEach(function (t) { if (t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var f = root.querySelector('.ncig-sidebar input, .ncig-sidebar a'); if (f) f.focus(); }
  }
  toggles.forEach(function (t) {
    t.addEventListener('click', function () { drawer(t.getAttribute('data-ncig-drawer') === 'open'); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-drawer-open')) drawer(false); });
  root.querySelectorAll('.ncig-sidebar a').forEach(function (a) {
    a.addEventListener('click', function () { if (root.classList.contains('is-drawer-open')) drawer(false); });
  });

  /* ---------- scroll-spy for the current section's step links ---------- */
  var subLinks = root.querySelectorAll('.ncig-nav li.is-current > ol a[href*="#"]');
  if (subLinks.length) {
    var heads = [];
    subLinks.forEach(function (a) {
      var h = document.getElementById(decodeURIComponent(a.hash.slice(1)));
      if (h) heads.push({ h: h, a: a });
    });
    var ticking = false;
    var spy = function () {
      ticking = false;
      var line = window.innerHeight * 0.25, cur = null;
      for (var i = 0; i < heads.length; i++) {
        if (heads[i].h.getBoundingClientRect().top <= line) cur = heads[i]; else break;
      }
      heads.forEach(function (x) { x.a.classList.toggle('is-active', x === cur); });
      if (cur && !root.classList.contains('is-drawer-open')) {
        var sb = cur.a.closest('.ncig-sidebar'), r = cur.a.getBoundingClientRect(), sr = sb.getBoundingClientRect();
        if (r.top < sr.top || r.bottom > sr.bottom) sb.scrollTop += r.top - sr.top - sr.height / 2;
      }
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(spy); } }, { passive: true });
    spy();
  }

  /* ---------- search ---------- */
  var mode = root.getAttribute('data-search') || 'local';
  var prefix = root.getAttribute('data-handle-prefix') || 'installer-guide';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function hilite(text, terms) {
    var out = esc(text);
    terms.forEach(function (t) {
      if (t.length < 2) return;
      out = out.replace(new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>');
    });
    return out;
  }
  function snippet(text, terms) {
    var low = text.toLowerCase(), i = -1;
    for (var k = 0; k < terms.length && i < 0; k++) i = low.indexOf(terms[k]);
    if (i < 0) return text.slice(0, 110);
    var s = Math.max(0, i - 40);
    return (s ? '…' : '') + text.slice(s, s + 120) + '…';
  }
  function localSearch(q) {
    var idx = window.NCIG_INDEX || [];
    var terms = q.toLowerCase().split(/\s+/).filter(Boolean);
    return Promise.resolve(idx.map(function (d) {
      var hay = (d.title + ' ' + d.section + ' ' + d.text).toLowerCase();
      var score = 0;
      for (var i = 0; i < terms.length; i++) {
        if (hay.indexOf(terms[i]) < 0) return null;
        if (d.title.toLowerCase().indexOf(terms[i]) > -1) score += 5;
        score += 1;
      }
      return { d: d, score: score };
    }).filter(Boolean).sort(function (a, b) { return b.score - a.score; }).slice(0, 8).map(function (r) {
      return { url: r.d.url, title: r.d.title, sub: r.d.section, text: snippet(r.d.text, terms) };
    }));
  }
  function shopifySearch(q) {
    // Online Store predictive search: pages only, then keep the guide's own handles.
    var u = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') +
      'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=page&resources[limit]=10&resources[options][fields]=title,body';
    return fetch(u).then(function (r) { return r.json(); }).then(function (j) {
      var pages = (j.resources && j.resources.results && j.resources.results.pages) || [];
      var terms = q.toLowerCase().split(/\s+/).filter(Boolean);
      return pages.filter(function (p) { return (p.handle || '').indexOf(prefix) === 0; }).map(function (p) {
        var body = (p.body || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ');
        return { url: p.url, title: p.title, sub: 'Installer Guide', text: snippet(body, terms) };
      });
    }).catch(function () { return []; });
  }
  root.querySelectorAll('.ncig-search').forEach(function (box) {
    var input = box.querySelector('input');
    var list = box.querySelector('.ncig-search__results');
    var timer, sel = -1;
    function render(items, q) {
      var terms = q.toLowerCase().split(/\s+/).filter(Boolean);
      sel = -1;
      list.innerHTML = items.length ? items.map(function (it) {
        return '<li><a href="' + esc(it.url) + '"><strong>' + hilite(it.title, terms) + '</strong>' +
          (it.sub && it.sub !== it.title ? ' <small>' + esc(it.sub) + '</small>' : '') +
          '<small>' + hilite(it.text, terms) + '</small></a></li>';
      }).join('') : '<li class="ncig-search__empty">No matches. Try "OCPP", "CT 3" or "firmware".</li>';
      list.hidden = false;
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { list.hidden = true; return; }
      timer = setTimeout(function () {
        (mode === 'shopify' ? shopifySearch(q) : localSearch(q)).then(function (items) { if (input.value.trim() === q) render(items, q); });
      }, 120);
    });
    input.addEventListener('keydown', function (e) {
      var links = list.querySelectorAll('a');
      if (e.key === 'Escape') { list.hidden = true; return; }
      if (!links.length || list.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        sel = (sel + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
        links.forEach(function (l, i) { l.setAttribute('aria-selected', i === sel ? 'true' : 'false'); });
        links[sel].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && sel > -1) {
        e.preventDefault(); window.location.href = links[sel].href;
      }
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) list.hidden = true; });
  });
})();

/* Tap a figure to view it full screen (diagrams and photos). */
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.ncig-body figure a');
    if (!a) return;
    var img = a.querySelector('img');
    if (!img) return;
    e.preventDefault();
    var box = document.createElement('div');
    box.className = 'ncig-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-label', img.alt || 'Image');
    box.innerHTML = '<button type="button" aria-label="Close">×</button><img alt="">';
    box.querySelector('img').src = a.getAttribute('href') || img.src;
    box.querySelector('img').alt = img.alt || '';
    function close() { box.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(k) { if (k.key === 'Escape') close(); }
    box.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
    document.body.appendChild(box);
  });
})();
